const REFRESH_LOCK_NAME = "admin-refresh-token";

/**
 * Serializes the actual refresh-token network call across browser tabs of
 * this origin, using the Web Locks API (native, no new dependency).
 *
 * Without this, two tabs racing to refresh the same refresh token — which is
 * now single-use/rotated server-side — would have one of them rejected and
 * forced to log out even though the user was still legitimately active in
 * that tab: only one refresh token is valid at a time, but each tab's own
 * single-flight guard (see services/api.js) only dedupes requests within
 * that one tab, not across tabs.
 *
 * `doRefresh` must read the refresh token from storage itself, and only once
 * actually invoked (not before the lock is granted) — a tab that had to wait
 * then picks up whatever token the previous lock-holder just rotated in via
 * localStorage, instead of the stale one it originally queued with. The
 * lock-holder must therefore also persist the new tokens *before* its
 * callback resolves (releasing the lock) — see services/api.js.
 */
export function withRefreshLock(doRefresh) {
  if (typeof navigator === "undefined" || !navigator.locks) {
    // No Web Locks support: fall back to calling directly. The backend's
    // atomic single-use rotation remains the correctness guarantee — a
    // losing tab in this fallback path is logged out as before, just
    // without this optimization.
    return doRefresh();
  }
  return navigator.locks.request(REFRESH_LOCK_NAME, doRefresh);
}
